import React from 'react';

// Import local assets
import medicalProfessionals from '../assets/images/medical-professionals.png';
import starBg from '../assets/icons/star-bg.svg';
import starInner from '../assets/icons/star-inner.svg';

const AuthRightSection: React.FC = () => {
  return (
    <div
      className="bg-[#f8f6f2] w-full h-full overflow-hidden relative flex flex-col"
      data-name="Illustration and plan"
    >
      {/* Image Section */}
      <div className="flex-1 flex items-center justify-center p-4 lg:p-8">
        <div className="w-full max-w-md lg:max-w-lg xl:max-w-xl aspect-square flex items-center justify-center">
          <img
            src={medicalProfessionals}
            alt="Medical professionals"
            className="w-full h-full object-contain"
            style={{
              objectPosition: 'center center',
            }}
            onError={(e) => {
              console.error('Failed to load image:', medicalProfessionals);
              // Fallback to background image approach if img tag fails
              const target = e.target as HTMLImageElement;
              const parent = target.parentElement;
              if (parent) {
                parent.style.backgroundImage = `url('${medicalProfessionals}')`;
                parent.style.backgroundSize = 'contain';
                parent.style.backgroundPosition = 'center center';
                parent.style.backgroundRepeat = 'no-repeat';
                target.style.display = 'none';
              }
            }}
          />
        </div>
      </div>

      {/* Text Content Section */}
      <div className="px-6 lg:px-[10%] pb-8 lg:pb-[80px] flex flex-col gap-4 lg:gap-6 items-center justify-center">
        <div className="font-['Ovo',_serif] text-[#000000] text-[24px] lg:text-[28px] xl:text-[32px] text-center uppercase w-full">
          Get ready to tout your CLOUT!
        </div>
        <div className="flex flex-col items-start justify-start w-full">
          <div className="flex flex-row gap-3 items-center justify-start w-full">
            <div className="relative shrink-0 size-6" data-name="star_purple500">
              <img alt="" className="absolute inset-0" loading="lazy" src={starBg} />
              <img
                alt=""
                className="absolute bottom-[12.5%] left-[8.333%] right-[8.333%] top-[8.333%]"
                loading="lazy"
                src={starInner}
              />
            </div>
            <div className="flex-1 font-['Ovo',_serif] font-normal text-[#000000] text-[16px] lg:text-[18px] text-left">
              Discover your initial CLOUT score for you and your industry peers
            </div>
          </div>
          <div className="flex flex-row gap-3 items-center justify-start w-full">
            <div className="relative shrink-0 size-6" data-name="star_purple500">
              <img alt="" className="absolute inset-0" loading="lazy" src={starBg} />
              <img
                alt=""
                className="absolute bottom-[12.5%] left-[8.333%] right-[8.333%] top-[8.333%]"
                loading="lazy"
                src={starInner}
              />
            </div>
            <div className="flex-1 font-['Ovo',_serif] font-normal text-[#000000] text-[16px] lg:text-[18px] text-left">
              Complete your profile to become CLOUT certified and increase your score.
            </div>
          </div>
          <div className="flex flex-row gap-3 items-center justify-start w-full">
            <div className="relative shrink-0 size-6" data-name="star_purple500">
              <img alt="" className="absolute inset-0" loading="lazy" src={starBg} />
              <img
                alt=""
                className="absolute bottom-[12.5%] left-[8.333%] right-[8.333%] top-[8.333%]"
                loading="lazy"
                src={starInner}
              />
            </div>
            <div className="flex-1 font-['Ovo',_serif] font-normal text-[#000000] text-[16px] lg:text-[18px] text-left">
              Invite peers to endorse you and build your CLOUT!
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AuthRightSection;
